import Axios from '../libs/AxiosPlugin'
import fun from './function.js'

const BASE_PATH = process.env.API_URL

const nologin = [
  'index/captcha',
  'user/login',
]
export default {
  //获取验证码
  post (url, params) {
    // 获取本地token
    let token = fun.getToken()
    let header = {}
    header['Content-Type'] = 'application/json'
    if (token) {
      header['token'] = token
    }
    if (!token && !fun.inArray(url, nologin)) {
      //未登录状态，不在不需要登录的接口中直接跳转登录
      fun.msg('请登录后再试1', 3, () => {
        // window.location.href = '/login'
      })
      return
    }

    return Axios.post(`${BASE_PATH}/${url}`, {...params}, {headers: header}).catch(err => {
      fun.msg(err.message, 3)
      // fun.logout()
    })
  },
  //登录
  get (url, params) {
    // 获取本地token
    let token = fun.getToken()
    let header = {}
    header['Content-Type'] = 'application/json'
    if (token) {
      header['token'] = token
    }
    if (!token && !fun.inArray(url, nologin)) {
      //未登录状态，不在不需要登录的接口中直接跳转登录
      fun.msg('请登录后再试', 3, () => {
        window.location.href = '/login'
      })
      return
    }
    return Axios.get(`${BASE_PATH}/${url}`, { ...params, headers: header });
    // return Axios.get(`${BASE_PATH}/${url}`, {...params, token: token}, {headers: header})
  },

  upload(url, formData) {
    let token = fun.getToken()
    let header = {}
    header['Content-Type'] = 'multipart/form-data'
    if (token) {
      header['token'] = token
    }
    if (!token && !fun.inArray(url, nologin)) {
        // 未登录状态，不在不需要登录的接口中直接跳转登录
        fun.msg('请登录后再试', 3, () => {
            // window.location.href = '/login'
        });
        return;
    }

    return Axios.post(`${BASE_PATH}/${url}`, formData, { headers: header })
        .catch(err => {
            fun.msg(err.message, 3);
            // fun.logout();
        });
}
}



// WEBPACK FOOTER //
// ./src/utils/request.js